module.exports =
  home:
    index: '/'
    pricing: '/pricing'
    screenprinting: '/screenprint'
    dtg: '/dtg'
    tshirt: '/'
    sublimation: '/sublimation'
    shopify: '/shopify'
    woocommerce: '/woocommerce'
    case: '/sublimation'
    mug: '/sublimation'
    contact: '/contact'
  company:
    about: '/company/about'
    terms: '/company/terms'
    privacy: '/company/privacy'
  auth:
    login: '/auth/login'
    logout: '/auth/logout'
    addSubUsers: '/auth/addSubUsers'
    register: '/auth/register'
    registerSubUser: '/auth/registerSubUser'
    reset: '/auth/reset'
    changePassword: '/auth/change'
    forgot: '/auth/forgot'
    facebook:
      login: '/auth/facebook/login'
      callback: '/auth/facebook/callback'
    google:
      login: '/auth/google/login'
      callback: '/auth/google/callback'
    success: '/auth/success'
    assume: '/auth/assume/:userId'
    unassume: '/auth/unassume'
    crmUpdate: '/auth/crmUpdate'
    totp:
      user: '/auth/totp/user'
    coupa: '/auth/coupa'
    twilio:
      createVerificationSms: '/auth/createVerificationSms'
  policies:
    resellerLicense: '/policies/resellerLicense'
    productionPrinters: '/policies/productionPrinters'
    moduleVersions: '/policies/moduleVersions'
  catalog:
    base: '/_catalog'
    product: '/_catalog#'
  docs:
    base: '/docs/'
  services:
    base: '/services'
  press:
    base: '/press'
  status:
    base: '/status'
    secret: '/status/secret'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/website.coffee